<template>
  <el-row class="mx-5">
    <el-col>
      <el-card shadow="never">
        <PageHeader
          slot="header"
          @onCreate="onCreate"
        />
        <div>
          <el-dialog
            :title="module ? 'Editar módulo' : 'Cadastrar módulo'"
            :visible.sync="registering"
            fullscreen
            center
          >
            <Register
              @onSave="getModules(filters); onCancel()"
              @cancel="onCancel()"
            />
          </el-dialog>
          <el-dialog
            :title="`Informação do módulo ${ module ? module.name : ''}`"
            width="30%"
            class="with-border"
            :visible.sync="showing"
            fullscreen
            center
          >
            <PreviewModule
              v-if="showing && module"
              :module="module"
            />
          </el-dialog>
          <FilterList v-model="search" />
        </div>

        <List @changed="getModules(filters); onCancel()">
          <template slot-scope="{row}">
            <el-button-group>
              <el-button
                v-if="permissions.includes('update-module')"
                size="mini"
                icon="el-icon-edit"
                :disabled="!!row.invalidated_at"
                title="Editar módulo"
                @click="onEdit(row)"
              >
                Editar
              </el-button>
              <el-button
                size="mini"
                type="info"
                icon="el-icon-view"
                @click="onShow(row)"
              >
                Visualizar
              </el-button>
              <UploadExamButton :module="row" />
              <el-button-group />
            </el-button-group>
          </template>
        </List>
        <div class="d-flex justify-content-center p-2">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="meta.total"
            :current-page.sync="meta.current_page"
          />
        </div>
      </el-card>
    </el-col>
  </el-row>
</template>
<script>

import List from "@/admin/Pages/module/components/List"
import FilterList from "@/admin/Pages/module/components/FilterList"
import UploadExamButton from "@/admin/components/UploadModuleExamButton"
import Register from "@/admin/Pages/module/components/Register"
import PreviewModule from "@/admin/Pages/module/components/PreviewModule"
import { mapActions, mapMutations, mapGetters } from 'vuex'
import {defaultLoadingConfig} from "@/admin/constants/general"

export default{
    components: {
        List,
        Register,
        PreviewModule,
        FilterList,
        UploadExamButton
    },
    data() {
        return {
          registering: false,
          showing: false,
          search: '',
          meta : {
              current_page: 1,
              total: 10
          },
        }
    },
    computed:{
      ...mapGetters(['permissions','module']),
      filters(){
        return `${this.search}&page=${this.meta.current_page}`
      }
    },
    watch:{
      filters: {
        handler(){
            clearTimeout(this._timerId)
            this._timerId = setTimeout(() => {
                this.$loading(defaultLoadingConfig);
            this.getModules(this.filters)
                .then((r)=> {
                    this.meta = r.data.meta;
                }).finally(()=>this.$loading().close())
            }, 500)
        },
        immediate: true,
      },
    },
    methods:{
        ...mapActions(['getModules','getModule']),
        ...mapMutations(['SET_MODULE']),
        onEdit(module){
          this.getModule({id: module.id}).then(()=> this.registering = true);
        },
        onCreate(){
            this.SET_MODULE(null);
            this.registering = true;
        },
        onShow({ id }){
          this.getModule({ id }).then(() => this.showing = true);
        },
        onCancel(){
            this.registering = false;
            this.SET_MODULE(null);
        },
    },
}
</script>
